import { useState } from 'react'
import { db } from '../../services/db'
import type { CredentialsType } from '../../utils/types'

export const useCredentials = () => {
  const [loadingCreate, setLoadingCreate] = useState(false)

  const registerCredentials = async (data: CredentialsType) => {
    await db.credentials.clear()
    setLoadingCreate(true)

    db.credentials.add(data).finally(() => setLoadingCreate(false))
  }

  const getCredentials = async () => {
    const credentials = await db.credentials.toArray()

    return credentials.length ? credentials[0] : null
  }

  return {
    register: registerCredentials,
    isLoading: loadingCreate,
    getData: getCredentials,
  }
}
